import Toolbox from "./components/Toolbox";
import "../../styles/Index.scss";
import TopSection from "./components/TopSection";
import Header from "Dashboard/components/Header";
import BottomSection from "./components/BottomSection";
import { useCallback, useEffect, useState } from "react";
import {
  getOutputs,
} from "./outputSlice";
import { useAppDispatch } from "hooks/hooks";
import usePagingAndSort,
{
  IGetPageRequestParams,
  IUpdateStateAfterSearchParams
} from "hooks/pagingAndSort";
import { useForm } from "react-hook-form";
import { IOutputSearch } from "Dashboard/scenes/ConcreteBase/domain/IOutputSearch";

const Output = () => {
  const dispatch = useAppDispatch();

  const defaultGetOutputListItemsSearchParams: IOutputSearch = { searchQuery: undefined, };

  const [getOutputListItemsSearchParams, setGetOutputListItemsSearchParams]
    = useState<IOutputSearch>(
      defaultGetOutputListItemsSearchParams);

  const limit = 200;

  const {
    register: registerSearch,
    handleSubmit: handleSubmitSearch,
    reset: resetSearch,
    control: controlSearch,
    getValues: getValuesSearch,
    setFocus: setFocusSearch,
    setValue: setValueSearch
  } = useForm<IOutputSearch>({ defaultValues: defaultGetOutputListItemsSearchParams });

  const getOutputListItemsWithPaging = useCallback((
    pagingParams: IGetPageRequestParams,
    abortSignal: AbortSignal,
    updateStateAfterFetch: (updateStateParams: IUpdateStateAfterSearchParams) => void
  ): void => {
    dispatch(getOutputs({
      getOutputListItemsSearchParams,
      pagingParams,
      abortSignal,
      updateStateAfterFetch
    }));
  }, [dispatch, getOutputListItemsSearchParams]);

  const { doSortBy, resetAfterSearch, lastElementRef, handleScroll } =
    usePagingAndSort(
      getOutputListItemsWithPaging,
      limit,
    );

  useEffect(() => {
    resetAfterSearch();
  }, [getOutputListItemsSearchParams]);

  return (
    <>
      <Header title="Betonska Baza - IZLAZ" />
      <Toolbox
        setGetOutputListItemsSearchParams={setGetOutputListItemsSearchParams}
        defaultGetOutputListItemsSearchParams={defaultGetOutputListItemsSearchParams}
        registerSearch={registerSearch}
        handleSubmitSearch={handleSubmitSearch}
        resetSearch={resetSearch}
        controlSearch={controlSearch}
        getValuesSearch={getValuesSearch}
        setFocusSearch={setFocusSearch}
        setValueSearch={setValueSearch}
      />
      <main className="lager-ex concrete-base-output">
        <TopSection
          lastTableElementRef={lastElementRef}
          handleScroll={handleScroll}
        />
        <BottomSection />
      </main>
    </>
  );
};

export default Output;
